// extracted by mini-css-extract-plugin
export default {"srOnly":"_3rqkN","expandedWidget":"_1kGVr","mobile":"_2Dny1","floating":"uN6lr","header":"CTUlT","chatroom":"_1ipcr"};